import { translate as t } from '@thoughtspot/i18n';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Link } from '@thoughtspot/radiant-react/widgets/link';
import { Toggle } from '@thoughtspot/radiant-react/widgets/toggle';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import styles from './auto-translation-toggle.module.scss';
export const AutoTranslationToggle = ({ enabled, pendingValue, onToggleChange, onSave, onEdit, onCancel, isEditing, isClusterContext, clusterEnabled, learnMoreUrl, saving = false, canModify, }) => {
    const editDisabled = !canModify || saving;
    const saveDisabled = saving || pendingValue === enabled;
    const getEditButtonTooltip = () => {
        if (isClusterContext) {
            return undefined;
        }
        if (!clusterEnabled) {
            return t('adminSection.autoTranslation.clusterDisabledInfo');
        }
        return t('adminSection.autoTranslation.clusterEnabledInfo');
    };
    const editButtonTooltip = getEditButtonTooltip();
    if (isEditing) {
        return (React.createElement(Vertical, { className: styles.editContainer },
            React.createElement("div", { className: styles.editHeader },
                React.createElement(Typography, { role: "heading", "aria-level": 2, variant: "p-large-bold", className: styles.title }, t('adminSection.autoTranslation.title')),
                React.createElement(Typography, { variant: "p", className: styles.description },
                    t('adminSection.autoTranslation.description'),
                    ' ',
                    React.createElement(Link, { href: learnMoreUrl, target: "_blank" }, t('adminSection.autoTranslation.learnMore')))),
            React.createElement(Horizontal, { className: styles.editFormRow },
                React.createElement(Typography, { variant: "p", className: styles.editFormLabel }, t('adminSection.autoTranslation.status')),
                React.createElement(Toggle, { "data-testid": "auto-translation-toggle", label: pendingValue
                        ? t('adminSection.autoTranslation.enabled')
                        : t('adminSection.autoTranslation.disabled'), checked: pendingValue, onChange: e => onToggleChange(e.target.checked), disabled: !canModify || saving, labelPosition: "right" })),
            React.createElement("div", { className: styles.editActionsRow },
                React.createElement(Button, { text: t('adminSection.autoTranslation.saveConfig'), onClick: onSave, isDisabled: saveDisabled }),
                React.createElement(Button, { text: t('adminSection.autoTranslation.cancelConfig'), type: "secondary", onClick: onCancel, isDisabled: saving }))));
    }
    return (React.createElement(Vertical, { className: styles.settingContainer },
        React.createElement("div", { className: styles.headerRow },
            React.createElement("div", null,
                React.createElement(Typography, { role: "heading", "aria-level": 2, variant: "p-large-bold", className: styles.title }, t('adminSection.autoTranslation.title')),
                React.createElement(Typography, { variant: "p", className: styles.description },
                    t('adminSection.autoTranslation.description'),
                    ' ',
                    React.createElement(Link, { href: learnMoreUrl, target: "_blank" }, t('adminSection.autoTranslation.learnMore')))),
            React.createElement(Button, { text: t('adminSection.autoTranslation.editConfig'), type: "secondary", onClick: onEdit, isDisabled: editDisabled, "data-tooltip-content": editButtonTooltip, "data-tooltip-align": "center", "data-tooltip-position": "bottom" })),
        React.createElement("div", { className: styles.settingContent },
            React.createElement(Horizontal, { className: styles.statusRow },
                React.createElement(Typography, { variant: "p", className: styles.statusLabel }, t('adminSection.autoTranslation.status')),
                React.createElement(Typography, { variant: "p", className: styles.statusValue }, enabled
                    ? t('adminSection.autoTranslation.enabled')
                    : t('adminSection.autoTranslation.disabled'))))));
};
//# sourceMappingURL=auto-translation-toggle.js.map